import {
  ACCOUNT_FETCH_SUCCESS,
  SET_ACCOUNT,
  SET_ACCOUNT_PASSWORD,
  ACCOUNT_UPDATE_SUCCESS,
  ACCOUNT_PASSWORD_UPDATE_SUCCESS
} from '../constant/actionType';
import logger from '../util/logger';

export const initialState = {
  passwordDraft: { newPassword: '', oldPassword: '' },
  userDraft: {}
};

const accountReducer = (state = initialState, { type, data }) => {
  switch (type) {
    case ACCOUNT_FETCH_SUCCESS: {
      logger.debug(`${ACCOUNT_FETCH_SUCCESS}: ${JSON.stringify(data)}`);

      return { ...state, data };
    }

    case SET_ACCOUNT: {
      logger.debug(`${SET_ACCOUNT}: ${JSON.stringify(data)}`);

      return { ...state, userDraft: data };
    }

    case SET_ACCOUNT_PASSWORD: {
      logger.debug(`${SET_ACCOUNT_PASSWORD}: ${JSON.stringify(data)}`);

      const passwords = data;

      return { ...state, passwordDraft: passwords };
    }

    case ACCOUNT_UPDATE_SUCCESS: {
      logger.debug(`${ACCOUNT_UPDATE_SUCCESS}: ${JSON.stringify(data)}`);

      const { userDraft } = state;

      return { ...state, userDraft };
    }

    case ACCOUNT_PASSWORD_UPDATE_SUCCESS: {
      logger.debug(`${ACCOUNT_PASSWORD_UPDATE_SUCCESS}: ${JSON.stringify(data)}`);

      const { passwordDraft } = state;

      return { ...state, passwordDraft };
    }
    default:
      return state;
  }
};

export default accountReducer;
